(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function parseJSON(data) {
  if (data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      return null;
    }
  }
}
function handleMessage(event) {
  var data = parseJSON(event.data);
  if (data && data.source && data.height) {
    var iframes = document.querySelectorAll('iframe[src*="' + data.source + '"]');
    [].slice.call(iframes).forEach(function (iframe) {
      if (iframe.style) {
        iframe.style.height = data.height + 'px';
        iframe.scrolling = 'no';
      }
    });
  }
}
if (!window.instanewsScriptLoaded) {
  var iframes = document.querySelectorAll('iframe');
  [].slice.call(iframes).forEach(function (iframe) {
    iframe.contentWindow.postMessage(JSON.stringify({
      'instanews': true,
      'message': 'requestHeight'
    }), '*');
  });

  // make sure this only get executed once
  window.instanewsScriptLoaded = true;

  // start listening to postmessages
  window.addEventListener('message', handleMessage);
}

},{}]},{},[1]);
